<template>
  <div style="display: inline">
    <!-- <b-button variant="link" v-if="!mounted" size="sm">
        <b-skeleton type="avatar" height="2em" width="2em" animation="throb"
        ></b-skeleton>
    </b-button> -->
    <div>
      <div v-if="!ready">
        <b-button variant="outline-dark" v-if="!loading" @click="Connect()"
          >Connect Wallet</b-button
        >
        <b-button
          variant="outline-dark"
          v-if="loading"
          @click="Connect()"
          disabled
        >
          <b-spinner small></b-spinner> Connect Wallet</b-button
        >
      </div>
      <b-dropdown variant="link" dropleft v-else no-caret>
        <template #button-content>
          <b-avatar size="sm" variant="light" :src="profile"></b-avatar>
        </template>
        <b-dropdown-text>
          <div class="text-center">
            <b-avatar variant="light" :src="profile"></b-avatar>
            <br>
            <span>{{ Clip(address, 10) }}</span
            ><br />
            <span>{{ Clip(storage, 10) }}</span>
          </div>
        </b-dropdown-text>
        <b-dropdown-divider></b-dropdown-divider>

        <b-dropdown-item @click="Disconnect()"> Log Out </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>
<script>
// Blockies
import { createIcon } from "@download/blockies";

export default {
  name: "wallet-connector",
  data() {
    return {
      loading: false,
      error: false,
    };
  },
  computed: {
    address() {
      return this.$store.state.ethereum.profile
        ? this.$store.state.ethereum.profile[0]
        : null;
    },
    profile() {
      let address = this.$store.state.ethereum.profile;
      if (address && address["length"]) {
        console.log("Generate Image: ", address);
        return this.GenerateImage(address[0]);
      }
      return null;
    },
    web3() {
      return this.$store.state.ethereum.web3;
    },
    storage() {
      try{
        return this.$store.state.ethereum.storage['id']
      }
      catch(err) {
        return ""
      }
    },
    ready() {
      return this.$store.state.ethereum.ready;
    },
    mounted() {
      return this.$store.state.ethereum.mounted;
    },
  },
  methods: {
    DownloadMetamask() {
      window.open("https://metamask.io", "_blank");
    },
    Connect() {
      this.loading = true;
      this.$store
        .dispatch("ethereum/connect")
        .catch((err) =>
          this.$bvToast.toast(err["message"] || err, {
            title: "Error",
            variant: "danger",
          })
        )
        .finally(() => (this.loading = false));
    },
    Disconnect() {
      this.$store.dispatch("ethereum/disconnect");
    },
    Clip(s, f, l) {
      let first = f || 3;
      let last = l || 4;
      if (!s) {
        return s;
      }
      if (s.length < first + last) {
        return s;
      }
      return s.slice(0, first) + "..." + s.slice(s.length - last, s.length);
    },
    GenerateImage(address) {
      var icon = createIcon({
        // All options are optional
        seed: address, // seed used to generate icon data, default: random
        // color: '#dfe', // to manually specify the icon color, default: random
        // bgcolor: '#aaa', // choose a different background color, default: white
        // size: 15, // width/height of the icon in blocks, default: 10
        // scale: 3 // width/height of each block in pixels, default: 5
      });
      return icon.toDataURL();
    },
  },
};
</script>